import React from 'react';
import ModalForm from '../components/ModalFormPurchase';
function PurchasePage(){
    return(
        <div className='Purchase'>
        <ModalForm/>
        </div>
    )
}
export default PurchasePage;